import './GenresList.scss'
import noImg from '../../assets/img/no-img.webp'
import drama from '../../assets/img/drama.jpg'
import comedy from '../../assets/img/comedy.jpg'
import crime from '../../assets/img/crime.jpg'
import adventure from '../../assets/img/adventure.jpg'
import family from '../../assets/img/family.jpg'
import fantasy from '../../assets/img/fantasy.jpg'
import history from '../../assets/img/history.jpg'
import thriller from '../../assets/img/thriller.jpg'
import war from '../../assets/img/war.jpg'
import animation from '../../assets/img/animation.jpg'
import western from '../../assets/img/western.jpg'
import action from '../../assets/img/action.jpg'
import documentary from '../../assets/img/documentary.jpg'
import tvMmovie from '../../assets/img/tv-movie.jpg'
import music from '../../assets/img/music.jpg'
import romance from '../../assets/img/romance.jpg'
import mystery from '../../assets/img/mystery.jpg'
import standUp from '../../assets/img/stand-up.jpg'
import scifi from '../../assets/img/scifi.jpg'
import horror from '../../assets/img/horror.jpg'
import { FC } from 'react'
import { GenreProps } from '../../pages/GenresPage/GenresPage'


export const GenresList: FC<GenreProps> = ({ genre }) => {

  const genreImages: { [key: string]: string } = {
    drama: drama,
    comedy: comedy,
    crime: crime,
    adventure: adventure,
    family: family,
    fantasy: fantasy,
    history: history,
    thriller: thriller,
    war:war,
    animation:animation,
    western:western,
    action:action,
    documentary:documentary,
    'tv-movie':tvMmovie,
    music:music,
    romance:romance,
    mystery:mystery,
    'stand-up':standUp,
    scifi:scifi,
    horror:horror,
  };

  function getGenreImage(genre: string) {
    return genreImages[genre] || noImg;
  }

  const imageUrl = getGenreImage(genre);

  return (
    <article className='card'>
      <img className='card__img' src={imageUrl} alt={genre} />
      <div className='card__wrap'>
        <h3 className='card__title'>{genre}</h3>
      </div>
    </article>
  )
}